import { styled } from "@mui/material/styles";
import { Card, Box, Typography } from "@mui/material";
import colors from "../../theme/Colours";

export const TrackingBox = styled(Box)(() => ({
  backgroundColor: colors.primaryButtonOrange,
}));

export const ServiceCardRoot = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2),
  height: "100%",
  width: "100%",
  maxWidth: 400,
  borderRadius: 0,
  minHeight: 160,
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: theme.spacing(0.5),
  backgroundColor: colors.serviceCardBackground,
  boxShadow: "none",
  transition: "box-shadow 0.2s",
}));

export const ServiceCardContent = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  flex: 1,
  justifyContent: "center",
  gap: theme.spacing(2),
  paddingLeft: theme.spacing(2),
  margin: theme.spacing(2),
}));

export const TextContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(0.5),
}));

export const ServiceTitle = styled(Typography)({
  fontWeight: 400,
  fontFamily: "Poppins, sans-serif",
  fontSize: "32px",
  textAlign: "left",
  color: colors.titleDarkText,
}) as typeof Typography;

export const ServiceSubtitle = styled(Typography)({
  fontSize: "14px",
  fontWeight: 400,
  fontFamily: "Plus Jakarta Sans, sans-serif",
  textAlign: "left",
  minHeight: "40px",
  letterSpacing: "0.5px",
  color: colors.serviceSubtitleText,
}) as typeof Typography;

export const ServiceLink = styled(Box)(({ theme }) => ({
  alignSelf: "flex-start",
  fontFamily: "Plus Jakarta Sans, sans-serif",
  fontSize: "14px",
  fontWeight: 700,
  color: colors.primaryButtonOrange,
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(0.5),
  cursor: "pointer",
  "&:hover": {
    textDecoration: "none",
  },
}));

export const ServiceHeadingTitle = styled(Typography)(() => ({
  fontFamily: "DM Sans, sans-serif",
  fontWeight: 400,
  fontSize: "60px",
  lineHeight: "60px",
  letterSpacing: "1px",
  textAlign: "center",
  color: colors.background2,
})) as typeof Typography;

export const ServiceHeadingSubtitle = styled(Typography)(() => ({
  fontFamily: "Plus Jakarta Sans, sans-serif",
  fontWeight: 300,
  letterSpacing: "1px",
  fontSize: "16px",
  color: colors.background2,
})) as typeof Typography;

export const ServiceHeadingContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  paddingTop: "64px",
  backgroundColor: colors.primaryButtonOrange,
}));
